import { Fake } from "components/layout/skeleton/Fake";
import { Box, Grid } from "@mui/material";
import { Heading } from "../../../../layout/page/Heading";
import { usePriorityGridStyles } from "components/layout/event/priority_judge/usePriorityGridStyles";

export const PriorityJudgePageSkeleton = () => {
    return (
        <div className={"skeleton"} role="status" aria-label="loading">
            <Heading title="Priority judge" borderless/>
            <PriorityTableSkeleton/>
        </div>
    );
};

const PriorityTableSkeleton = () => {
    const size = 4;
    const { gridBoxStyles, gridContainerStyles, gridItemStyles, gridItemCenteredStyles } = usePriorityGridStyles();
    return (
        <Box sx={gridBoxStyles}>
            <Grid
                container
                spacing={1.5}
                sx={gridContainerStyles}
            >
                <Grid size={1} sx={gridItemCenteredStyles}>
                    <Fake size={10}/>
                </Grid>
                <Grid size={11} sx={gridItemStyles}>
                    <Fake size={10}/>
                </Grid>
                {Array(size).fill(1).map((_, index) => (
                    <PriorityRowSkeleton key={index} />
                ))}
            </Grid>
        </Box>
    );
};

const PriorityRowSkeleton = () => {
    const { gridItemCenteredStyles } = usePriorityGridStyles();

    return (
        <>
            <Grid size={1} sx={gridItemCenteredStyles}>
                <Fake size={5} />
            </Grid>
            <Grid size={11} sx={(theme) => ({
                background: theme.palette.background.mid,
                minHeight: theme.spacing(7)
            })}/>
        </>
    );
};
